<template>
  <div class="c-layout-page">
    <layer-component v-for="(item,index) in layers"
                     :key="index"
                     :item="item"
                     :isDraggable="isDraggable"
                     :isDragging="isDragging"></layer-component>
    <module-component v-for="(item,index) in moduleList"
                      :key="item.mark"
                      v-bind="item"
                      :isDraggable="isDraggable"
                      :margin="margin"
                      :rowHeight="rowHeight"
                      :rowWidth="rowWidth">
    </module-component>
    <addModule @addModule="onAddModule"></addModule>
  </div>
</template>
<script>
  import Vue from 'vue';
  import {mapGetters} from 'vuex'
  export default {
    provide() {
      return {
        eventBus: null
      }
    },
    data(){
      return {
        layers: [],
        margin: [20, 20],
        rowHeight: 333,
        rowWidth: 616,
        row: 3,
        col: 5,
        isDragging: false,
        direction: false,//移动的方向
        mousePaddingDistance: {},
        dragItem: {},

        globalTimer: null,
      }
    },
    computed: {
      ...mapGetters(['isDraggable', 'moduleList']),
    },
    watch: {
      moduleList: {
        handler: 'updateLayers',
        deep: true
      }
    },
    methods: {
      dragEvent(eventName, {mark, mouseX, mouseY, dragX, dragY, dragH, dragW, mousePaddingDistance}){
        switch (eventName) {
          case 'dragstart': {
            this.isDragging = true;
            this.mousePaddingDistance = mousePaddingDistance;
            //记录
            this.dragItem = {mark, mouseX, mouseY, dragX, dragY, dragH, dragW}
            break;
          }
          case 'drag': {
            //被拖拽中模块的左上角 left top 值 tip: 被拖拽中指的是拖拽过程中跟随鼠标移动的模块
            const left = mouseX - this.mousePaddingDistance.left,
              top = mouseY - this.mousePaddingDistance.top;
            //目标模块的坐标
            const {x: aimsX, y: aimsY} = this.calcXY(top, left);

            //判断移动的方向
            const direction = this.calcDirection(aimsX, aimsY, top, left);

            if (!direction) return false;

            //预生成移动后的坐标
            const {x: dragAfterX, y: dragAfterY} = this.calcDragAfterXY(direction, aimsX, aimsY)

            //判断是否可移动
            if ((dragAfterX === dragX && dragAfterY === dragY) || !this.calcIsMoving(dragAfterX, dragAfterY, dragW, dragH)) {
              return false;
            }

            //找出预移动后被覆盖的模块
            const {status, coveredModule, coveredKeys} = this.calcIsCover(this.layers, dragAfterX, dragAfterY, dragW, dragH, mark)

            if (status) {
              //判断被覆盖的模块预移动后是否合理
              //预重组layers
              const layers = this.virtualLayers(dragAfterX, dragAfterY, dragX, dragY, dragW, dragH, mark)
              for (let i = 0, item; i < coveredModule.length; i++) {
                item = coveredModule[i];
                const {x: dropAfterX, y: dropAfterY} =
                  this.calcDropAfterXY(dragAfterX, dragAfterY, dragX, dragY, dragW, dragH, item.x, item.y, item.w, item.h);
                if (!this.calcIsMoving(dropAfterX, dropAfterY, item.w, item.h)) {
                  return false
                }
                if (this.calcIsCover(layers, dropAfterX, dropAfterY, item.w, item.h, item.mark).status) {
                  return false
                }
                coveredKeys[item.mark] = {x: dropAfterX, y: dropAfterY}
              }

              this.moduleList.forEach(item => {
                if (coveredKeys[item.mark]) {
                  Object.assign(item, coveredKeys[item.mark])
                }
              })
            }
            //被拖拽模块
            const dragItem = this.moduleList.find(item => item.mark === mark);
            //进行移动
            Object.assign(dragItem, {x: dragAfterX, y: dragAfterY})
            break;
          }
          case 'dragend': {
            this.isDragging = false;
            //清除
            this.mousePaddingDistance = {}
            this.dragItem = {}
            break;
          }
        }
      },
      dropEventHandler(eventName, {mark, mouseX, mouseY, dropX, dropY, dropH, dropW,}){
        return false;
        //被拖拽中模块的左上角 left top 值 tip: 被拖拽中指的是拖拽过程中跟随鼠标移动的模块
        const left = mouseX - this.mousePaddingDistance.left,
          top = mouseY - this.mousePaddingDistance.top;

        //判断移动的方向
        const direction = this.calcDirection(dropX, dropY, top, left);

        if (!direction) return false;

        const {mark: dragMark, dragX, dragY, dragW, dragH} = this.dragItem;
        //预生成移动后的坐标
        const {x: dragAfterX, y: dragAfterY} = this.calcDragAfterXY(direction, dropX, dropY)

        //判断是否可移动
        if ((dragAfterX === dragX && dragAfterY === dragY) || !this.calcIsMoving(dragAfterX, dragAfterY, dragW, dragH)) {
          return false;
        }
        //找出预移动后被覆盖的模块
        const {status, coveredModule, coveredKeys} = this.calcIsCover(this.layers, dragAfterX, dragAfterY, dragW, dragH, dragMark)

        if (status) {
          //判断被覆盖的模块预移动后是否合理
          //预重组layers
          const layers = this.virtualLayers(dragAfterX, dragAfterY, dragX, dragY, dragW, dragH, dragMark)
          for (let i = 0, item; i < coveredModule.length; i++) {
            item = coveredModule[i];
            const {x: dropAfterX, y: dropAfterY} =
              this.calcDropAfterXY(dragAfterX, dragAfterY, dragX, dragY, dragW, dragH, item.x, item.y, item.w, item.h);
            if (!this.calcIsMoving(dropAfterX, dropAfterY, item.w, item.h)) {
              return false
            }
            if (this.calcIsCover(layers, dropAfterX, dropAfterY, item.w, item.h, item.mark).status) {
              return false
            }
            coveredKeys[item.mark] = {x: dropAfterX, y: dropAfterY}
          }

          this.moduleList.forEach(item => {
            if (coveredKeys[item.mark]) {
              Object.assign(item, coveredKeys[item.mark])
            }
          })
        }

        //被拖拽模块
        const dragItem = this.moduleList.find(item => item.mark === dragMark);
        //进行移动
        Object.assign(dragItem, {x: dragAfterX, y: dragAfterY})

      },
      createLayers(){
        const totalModule = this.row * this.col;
        let _row = 0, _col = 0;
        console.group('createLayers')
        for (let i = 0; i < totalModule; i++) {
          if (_col === this.col) {
            _row++;
            _col = 0;
          }
          const emp = {
            x: _col++,
            y: _row,
            w: 1,
            h: 1,
            isCovered: false,//是否被遮盖
            isAdd: false,
            index: i,
            itemMark: null,//被遮盖的上层模块key 对应this.items子集key
          }
          console.log(emp)
          this.layers.push(emp)
        }
        console.groupEnd()
//        this.updateLayers();
      },
      updateLayers(){
//        console.log('updateLayers')
        this.layers.map(val => {
          val.isCovered = false;
          val.itemMark = null;
        });
        this.moduleList.forEach(item => {
          const {x, y, w, h} = item
//          console.log({x, y, w, h})
          const minX = x, minY = y;
          const maxX = x + w, maxY = y + h;

          //找出layer中覆盖的点 修改isCovered状态
          this.layers.map(val => {
            if (val.x >= minX && val.x < maxX && val.y >= minY && val.y < maxY) {
              val.isCovered = true;
              val.itemMark = item.mark
            }
          });
        })
//        console.groupEnd()
      },
      virtualLayers(dragAfterX, dragAfterY, dragX, dragY, dragW, dragH, mark){
        const layers = JSON.parse(JSON.stringify(this.layers));
        for (let i = 1; i <= dragW; i++) {
          for (let j = 1; j <= dragH; j++) {
            layers[(dragX + i - 1) + (dragY + j - 1) * this.col].itemMark = null;
          }
        }
        for (let i = 1; i <= dragW; i++) {
          for (let j = 1; j <= dragH; j++) {
            layers[(dragAfterX + i - 1) + (dragAfterY + j - 1) * this.col].itemMark = mark;
          }
        }
        return layers;
      },
      processStyle({w, h, x, y}){
        return {
          width: `${w * this.rowWidth + (w - 1) * this.margin[0]}px`,
          height: `${h * this.rowHeight + (h - 1) * this.margin[1]}px`,
          top: `${y * this.rowHeight + (y + 1) * this.margin[0]}px`,
          left: `${x * this.rowWidth + (x + 1) * this.margin[1]}px`,
        }
      },
      /**
       * 计算x,y
       * @param top
       * @param left
       * @return {{x: number, y: number}}
       */
      calcXY(top, left) {
        const colWidth = this.rowWidth;
        let x = Math.floor((left - this.margin[0]) / (colWidth + this.margin[0]));
        let y = Math.floor((top - this.margin[1]) / (this.rowHeight + this.margin[1]));
        return {x, y};
      },
      /**
       * 计算移动的方向
       * @param aimsX
       * @param aimsY
       * @param top
       * @param left
       * @return {string}
       */
      calcDirection(aimsX, aimsY, top, left){
        let direction = null;
        //目标 x,y
        //目标左上角坐标
        const aimsLeft = aimsX * this.rowWidth + (aimsX + 1) * this.margin[1],
          aimsTop = aimsY * this.rowHeight + (aimsY + 1) * this.margin[0];
        const totalW = aimsLeft + this.rowWidth,
          totalH = aimsTop + this.rowHeight,
          halfW = aimsLeft + this.rowWidth / 2,
          halfH = aimsTop + this.rowHeight / 2;
        //判断拖拽物左上角在目标的哪个区域
        if (aimsLeft < left && left < halfW) {
          if (aimsTop < top && top < halfH) {
            direction = 'lt'
          }
          if (halfH < top && top < totalH) {
            direction = 'lb'
          }
        }
        if (halfW < left && left < totalW) {
          if (aimsTop < top && top < halfH) {
            direction = 'rt'
          }
          if (halfH < top && top < totalH) {
            direction = 'rb'
          }
        }
        return direction;
      },
      /**
       * 计算拖拽物移动后的x,y
       * @param direction
       * @param aimsX
       * @param aimsY
       */
      calcDragAfterXY(direction, aimsX, aimsY){
        let x, y;
        switch (direction) {
          case 'lt': {
            x = aimsX;
            y = aimsY;
            break;
          }
          case 'rt': {
            x = aimsX + 1;
            y = aimsY;
            break;
          }
          case 'lb': {
            x = aimsX;
            y = aimsY + 1;
            break;
          }
          case 'rb': {
            x = aimsX + 1;
            y = aimsY + 1;
            break;
          }
        }
        return {x, y}
      },
      /**
       * 被替换模块移动后的坐标
       * @param dragAfterX
       * @param dragAfterY
       * @param dragX
       * @param dragY
       * @param dragW
       * @param dragH
       * @param selfX
       * @param selfY
       * @return {{x: *, y: *}}
       */
      calcDropAfterXY(dragAfterX, dragAfterY, dragX, dragY, dragW, dragH, selfX, selfY){
        const stepX = dragW,
          stepY = dragH;
        if (dragAfterX - dragX > 0) {
          selfX -= stepX
        }
        if (dragAfterX - dragX < 0) {
          selfX += stepX
        }
        if (dragAfterY - dragY > 0) {
          selfY -= stepY
        }
        if (dragAfterY - dragY < 0) {
          selfY += stepY
        }
        return {
          x: selfX,
          y: selfY,
        }
      },
      /**
       * 是否可移动
       * @param selfX
       * @param selfY
       * @param selfW
       * @param selfH
       * @return {boolean}
       */
      calcIsMoving(selfX, selfY, selfW, selfH){
        //移动边界情况 考虑宽高
        if (selfX < 0 || selfX + selfW > this.col || selfY < 0 || selfY + selfH > this.row) {
          return false;
        }
        return true;
      },
      /**
       * 是否有覆盖物
       * @param layers
       * @param selfX
       * @param selfY
       * @param selfW
       * @param selfH
       * @param ignoreKey
       * @return {{status: boolean, coveredModule: Array, coveredKeys: {}}}
       */
      calcIsCover(layers, selfX, selfY, selfW, selfH, ignoreKey = null){
        const coveredModule = [], coveredKeys = {};
        for (let i = 1; i <= selfW; i++) {
          for (let j = 1; j <= selfH; j++) {
            const layer = layers[(selfX + i - 1) + (selfY + j - 1) * this.col];
            if (layer.itemMark && layer.itemMark !== ignoreKey && !coveredKeys[layer.itemMark]) {
              coveredKeys[layer.itemMark] = true;
              //保证数据不可影响因素
              coveredModule.push(JSON.parse(JSON.stringify(this.moduleList.find(item => item.mark === layer.itemMark))))
            }
          }
        }
        return {
          status: coveredModule.length !== 0,
          coveredModule,
          coveredKeys
        }
      },
      //计算将要覆盖的layer index
      calcWillCoveredIndex(x, y, w, h){
        const indexArr = [];
        for (let i = 1; i <= w; i++) {
          for (let j = 1; j <= h; j++) {
            indexArr.push((x + i - 1) + (y + j - 1) * this.col)
          }
        }
        return indexArr;
      },
      onAddModule(item){
        const notCoveredLayers = this.layers.filter(layer => !layer.isCovered);
        let addInfo = false, indexArr = [];
        for (let i = 0, layer; i < notCoveredLayers.length; i++) {
          if (addInfo) continue;
          layer = notCoveredLayers[i];
          if (this.calcIsMoving(layer.x, layer.y, item.w, item.h)) {
            indexArr = this.calcWillCoveredIndex(layer.x, layer.y, item.w, item.h)
            if (indexArr.every(item => !this.layers[item].isCovered)) {
              //说明可增加 记录下x,y
              addInfo = {
                id: item.id,
                mark: item.mark,
                x: layer.x,
                y: layer.y,
                w: item.w,
                h: item.h,
                componentName: item.componentName
              };
            }
          }
        }
        if (!addInfo) {
          //提示调整位置
          this.$message.warning('请调整位置')
          return false;
        }
        this.$store.dispatch('addModule', addInfo)
      },
      globalInterVal(){
        let now = new Date(), curHour = now.getHours(), curMinute = now.getMinutes();
        this.runTask(curHour, curMinute);
        this.globalTimer = setInterval(() => {
          now = new Date();
          curHour = now.getHours();
          curMinute = now.getMinutes();
//          console.log(curMinute);
//          console.log(now.getSeconds());
          this.runTask(curHour, curMinute)
        }, 60e3);
      },
      runTask(hour, minute){
        //分辨当前是否凌晨2点
        if (hour === 2 && minute === 0) {
          //重刷页面
          window.location.reload(false)
          return false;
        }
        //每小时刷新
        if (minute === 0) {
          this.$store.state.hourTimedTask.forEach(task => {
            if (typeof task === 'function') task()
          })
        }
        //每一分钟刷新
        if (minute % 1 === 0) {
          this.$store.state.oneMinutesTimedTask.forEach(task => {
            if (typeof task === 'function') task()
          })
        }
        //每五分钟刷新
        if (minute % 5 === 0) {
          this.$store.state.fiveMinutesTimedTask.forEach(task => {
            if (typeof task === 'function') task()
          })
        }
      }
    },
    mounted(){
      this.createLayers();
      this.$store.dispatch('getLayouts');
      //准点触发轮询定时器
      let timer = setTimeout(() => {
        this.globalInterVal();
        clearTimeout(timer);
        timer = null;
      }, Math.abs(new Date().getSeconds() - 60) * 1000)
    },
    created(){
      const self = this;

      self.dragEventHandler = function (eventType, params) {
        self.dragEvent(eventType, params);
      };

      self._provided.eventBus = new Vue();
      self.eventBus = self._provided.eventBus;
      self.eventBus.$on('dragEvent', self.dragEventHandler);
      self.eventBus.$on('dropEvent', self.dropEventHandler);
    },
    beforeDestroy(){
      //Remove listeners
      this.eventBus.$off('dragEvent', this.dragEventHandler);
      clearInterval(this.globalTimer);
      this.globalTimer = null;
    },
  }
</script>
<style lang="scss" scoped>
  @import '~@/assets/style/public.scss';

  $backgroundImage: #0A103D; //颜色/图片
  $moduleBorder: 1px solid rgba(33, 66, 144, 1);
  .c-layout-page {
    background: $backgroundImage;
    width: 100%;
    height: 100%;
    padding: 0;
    position: relative;
  }

</style>